import DefaultMainPage from "../../pages/DefaultMainPage";
import NewProbability from "./NewProbability";
import NewProbabilityEditor from "./NewProbabilityEditor";

const probabilityMenuItems = [
    {path: "/itemProbability", component: <NewProbability/>, label: '확률표 관리'},
    {path: "/itemProbability/editor", component: <NewProbabilityEditor/>, label: '에디터'},
]

export const itemProbabilityRoutes = {
    path: "/itemProbability",
    component: <DefaultMainPage buttons={probabilityMenuItems}/>,
    children: probabilityMenuItems
}